import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filtersSelectors } from '../Modules/filters';
import { transformTripsList } from 'utils/DataTransform/Trips/tripList';
import { getTimezone } from 'reducers/utils';
import { transformTripDetail } from 'utils/DataTransform/Trips/tripDetail';
import { BASE_TRIP_STATUS } from 'utils/constants/transport';

export const getTripListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getTimezone,
  (trips, timeZone) => {
    if (!trips) return [];
    return transformTripsList(trips, timeZone);
  },
);
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getTripFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getTripDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getTimezone,
  (tripDetail, timeZone) => {
    if (!tripDetail || Object.keys(tripDetail).length === 0) {
      return {};
    }
    return transformTripDetail(tripDetail, timeZone);
  },
);

export const tripIsResolved = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || Object.keys(details).length === 0) {
      return true; //there is no trip so mark it as resolved
    }
    return (
      //this method uses raw data so it needs currentStatus
      details.currentStatus === BASE_TRIP_STATUS.RESOLVED_ABORTED.id ||
      details.currentStatus === BASE_TRIP_STATUS.RESOLVED.id ||
      details.currentStatus === BASE_TRIP_STATUS.RESOLVED_CANCELLED.id
    );
  },
);
